import { createContext } from "react";
export const ToggleGroupContext = /*#__PURE__*/createContext(null);
//# sourceMappingURL=ToggleGroupContext.js.map